import React from 'react';
import { HelpCircle, ShieldQuestion } from 'lucide-react';
import type { CaseProfilePayload } from './caseProfile';

export interface UnconfirmedPostureBannerProps {
  profile: CaseProfilePayload | null | undefined;
  className?: string;
}

export function UnconfirmedPostureBanner({ profile, className }: UnconfirmedPostureBannerProps) {
  if (!profile || profile.posture_confirmed !== false) {
    return null;
  }

  const isThirdParty = profile.posture === 'third_party';

  const title = isThirdParty
    ? 'Posture unconfirmed — third-party not yet confirmed'
    : 'Posture unconfirmed — first-party assumed';

  const sub = isThirdParty
    ? 'Until an attorney or the intake wizard confirms third-party posture, the ceiling stays capped at the first-party supported net.'
    : 'The settlement ceiling is capped at the first-party supported net. The uncapped third-party path unlocks once an attorney or the intake wizard confirms case posture.';

  const Icon = ShieldQuestion ?? HelpCircle;

  return (
    <div
      className={`flex items-start gap-3 rounded-lg px-4 py-3 ${className || ''}`}
      style={{
        backgroundColor: 'var(--color-needs-human-tint)',
        border: '1px solid var(--color-needs-human-tint-bd)',
      }}
      role="status"
      data-testid="posture-banner"
    >
      <Icon
        className="h-5 w-5 shrink-0 mt-0.5"
        style={{ color: 'var(--color-needs-human)' }}
        aria-hidden="true"
      />
      <div>
        <div className="cs-body" style={{ color: 'var(--color-text-primary)', fontWeight: 600 }}>
          {title}
        </div>
        <div className="cs-meta mt-0.5" style={{ color: 'var(--color-text-secondary)' }}>
          {sub}
        </div>
      </div>
    </div>
  );
}

export default UnconfirmedPostureBanner;
